import { useState, useEffect, useCallback, useRef } from "react"

import Grid from '@material-ui/core/Grid'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutline'
import AddIcon from '@material-ui/icons/Add'
import SelectOption from "@base/Inputs/Select"
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Breadcrumbs from '@base/Breadcrumbs'
import Table from '@base/Table'
import Title from '@base/Title'
import Toast from '@base/Toast'
import Dialog from '@base/Dialog'
import DialogRemove from '@base/Dialog/DialogRemove'
import ButtonPrimary from '@base/Button'
import Filters from '@base/Filter'
import { ButtonCancel, ButtonSave } from '@base/Button/ButtonForm'
import TextField from '@base/Inputs/Text'
import {
  verifyPagingAndSorting,
  PAGE,
  SIZE,
  ASC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '@base/Table/Utils'

import AtividadeService from '@services/AtividadeService'

import { removePagingAndSorting } from '@helpers/PaginationHelper'

export const Atividade = () => {
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);

  const [idExcluir, setIdExcluir] = useState();
  const [openDialogRemove, setOpenDialogRemove] = useState(false);

  const [list, setList] = useState([]);

  const [page, setPage] = useState(PAGE);
  const [size, setSize] = useState(SIZE);
  const [defaultOrderBy,] = useState('descricao')
  const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: ASC }])
  const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
  const [totalPages, setTotalPages] = useState(TOTAL_PAGES);

  const [id, setId] = useState("");
  const [descricao, setDescricao] = useState("");
  const [seAtivo, setSeAtivo] = useState();
  const listagemSeAtivo = [{ value: false , label:'Inativo' }, {value: true , label:'Ativo'}];

  const [filtros, setFiltros] = useState([]);
  const [filtroSeAtivo, setFiltroSeAtivo] = useState('');
  const [filtroDescricao, setFiltroDescricao] = useState('');
  //const [filtroAtivo, setFiltroAtivo] = useState(false);
  const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);

  const toastRef = useRef(null);

  const pageName = 'Atividade';
  const breadcrumbs = [];

  const aplicarFiltros = () => {
    let f = [];

    if (filtroDescricao) f.push({ field: 'descricao', value: filtroDescricao });
    if (filtroSeAtivo !== "") f.push({ field: 'ativo', value: filtroSeAtivo });
    setFiltros(f);
    setQuantidadeFiltrosAplicados(f.length);
  }

  const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

  const limparFiltros = () => {
    setSort([{ orderBy: defaultOrderBy, order: ASC }]);
    setPage(PAGE);
    setSize(SIZE);

    setFiltros([]);
    setFiltroSeAtivo('');
    setFiltroDescricao('');

    setQuantidadeFiltrosAplicados(0);
  }

  const buttonAdd = () =>
    <Grid container spacing={3} >
      <Grid item xs={12} >
        <ButtonPrimary
          onClick={() => setOpenDialog(true)}
          name="Adicionar Nova Atividade"
          startIcon={<AddIcon />}
        />
      </Grid>
    </Grid>

  const buttonsSubmit = () =>
    <>
      <ButtonSave onClick={submit} />
      <ButtonCancel onBack={fecharModal} />
    </>

  const submit = () => {
    const atividade = {
      id: id,
      descricao: descricao,
      ativo: seAtivo,
    }
    if (!(descricao)) {
      toastRef.current.show("error", "Atividade deve ter uma descrição!");
    } else {
      if (id) {
        AtividadeService.editar(id, atividade).then(resultado => {
          setOpenDialog(false);
          carregarDados();
          toastRef.current.show("success", "Atividade Salva com Sucesso!");
        }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Editar a Atividade!"));
      } else {
        AtividadeService.adicionar(atividade).then(resultado => {
          setOpenDialog(false);
          carregarDados();
          toastRef.current.show("success", "Atividade Salva com Sucesso!");
        }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Criar uma Nova Atividade!"));
      }
      setId("");
      setDescricao("");
      setSeAtivo();
    }
  };

  const submitExcluir = (id, setLoading) => {
    AtividadeService.excluir(id).then(resultado => {
      toastRef.current.show("success", "Atividade Removida com Sucesso!");
    }).catch(error => {
      toastRef.current.show("error", "Erro ao remover a Atividade: " + error.response.data.mensagens.map(mensagen => mensagen).join(" ,"));
    }).finally(() => {
      fecharModalExcluir();
      setLoading(false);
    });
  };

  const abrirModalExclusao = (id) => {
    setOpenDialogRemove(true);
    setIdExcluir(id);
  };

  const tituloModalExclusao = () => `Excluir Atividade`;

  const textoExcluir = () => `Lembre-se que apenas atividades sem associação a processos e colaboradores podem ser removidas!`;

  const fecharModalExcluir = () => {
    setOpenDialogRemove(false);
    setIdExcluir();
    carregarDados();
  }

  const abrirModal = (id) => {
    AtividadeService.listarPorId(id).then(resultado => {
      const { id, descricao, ativo } = resultado.data;
      setId(id);
      setDescricao(descricao);
      setSeAtivo(ativo);
      setOpenDialog(true);
    }).catch(error => toastRef.current.show("error", "Ocorreu um problema ao Buscar a Atividade!"));
  }

  const tituloModal = () => `${id ? "Editar" : "Adicionar Novo"} Atividade`;

  const fecharModal = () => {
    setOpenDialog(false);
    setId("");
    setDescricao("");
    setSeAtivo();
    carregarDados();
  };

  const columns = [
    { label: 'ID', name: 'id', func: null, key: true },
    { label: 'Nome da Atividade', name: 'descricao', func: null, key: false },
    { label: 'Estado', name: 'ativo', func: (ativo) => ativo ? 'Ativo' : 'Inativo' , key: false, ordering: false },
  ];

  const actions = [
    {
      name: () => "Editar Atividade",
      func: abrirModal,
      icon: <EditOutlinedIcon />,
      disabled: () => false,
    },
    {
      name: () => "Excluir Atividade",
      func: abrirModalExclusao,
      icon: <DeleteOutlinedIcon />,
      disabled: () => false,
      color: 'secondary'
    },
  ]

  const carregarDados = useCallback(() => {
    const f = verifyPagingAndSorting(removePagingAndSorting(filtros), page, size, sort, filtroSeAtivo);

    AtividadeService.filtrar(f).then(resultado => {
      const { content, number, size, totalElements, totalPages } = resultado.data;
      setList(content);
      setPage(number);
      setSize(size);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
      setLoading(false);
    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Realizar os Filtros!"));

  }, [filtros, filtroSeAtivo, page, size, sort]);

  const handlePage = page => { setPage(page); setFiltroSeAtivo(true); };
  const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); setFiltroSeAtivo(true); };
  const handleSort = (orderBy, order) => {
    if (sort.find(s => s.orderBy === orderBy)) {
      let newSort = sort.filter(s => s.orderBy !== orderBy);
      newSort.splice(sort.indexOf(sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
      setSort([...newSort]);
    } else {
      setSort([...sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }]);
    }
    setFiltroSeAtivo(true);
  }
  const handleClearSort = (orderBy) => { setFiltroSeAtivo(true); orderBy ? setSort([...sort.filter(s => s.orderBy !== orderBy)]) : setSort([{ orderBy: defaultOrderBy, order: ASC }]) };
  const handleTotalPages = () => totalPages;
  const handleTotalElements = () => totalElements;

  useEffect(() => carregarDados(), [carregarDados]);

  return (
    <>
      <Toast ref={toastRef} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Breadcrumbs links={breadcrumbs} active={pageName} />
        </Grid>
      </Grid>
      <Title>{pageName}</Title>

      <Filters
        handleFilter={aplicarFiltros}
        handleFilterClear={limparFiltros}
        countFilters={contarFiltrosAplicados}
      >
        <Grid item container spacing={3}>
          <Grid item sm={12} lg={4}>
            <TextField
              label='Descrição da Atividade'
              value={filtroDescricao}
              name='filtroDescricao'
              onChange={(e) => setFiltroDescricao(e.target.value)}
            />
          </Grid>
          <Grid item sm={3} lg={3}>
            <SelectOption
              label='Estado da Atividade'
              value={filtroSeAtivo}
              name='filtroSeAtivo'
              onChange={(e) => setFiltroSeAtivo(e.target.value)}
              options={listagemSeAtivo}
              />
          </Grid>

        </Grid>
      </Filters>

      <Table
        columns={columns}
        tableData={list}
        actions={actions}
        page={page}
        handlePage={handlePage}
        handleTotalPages={handleTotalPages}
        handleTotalElements={handleTotalElements}
        rowsPerPage={size}
        handleRowsPerPage={handleRowsPerPage}
        sort={sort}
        handleSort={handleSort}
        handleClearSort={handleClearSort}
        loading={loading}
      />

      <Dialog
        maxWidth={"sm"}
        fullWidth={true}
        closeDialog={fecharModal}
        openDialog={openDialog}
        title={tituloModal()}
        actions={buttonsSubmit()}
      >
        <Grid container spacing={3}>
          <Grid item lg={12}>
            <TextField
              label='Descrição'
              required
              value={descricao}
              name="descricao"
              autoComplete="off"
              onChange={(e) => setDescricao(e.target.value)}
            />
          </Grid>

          <Grid item lg={12}>
          <FormControlLabel
                  control={
                          <Checkbox
                                  checked={seAtivo}
                                  value={seAtivo}
                                  onChange={(e) => setSeAtivo(e.target.checked)}
                                  color="primary"
                          />
                  }
                  label="Atividade está ativa"
          />
          </Grid>

        </Grid>
      </Dialog>

      {buttonAdd()}

      <DialogRemove
        maxWidth={"sm"}
        id={idExcluir}
        text={textoExcluir()}
        close={fecharModalExcluir}
        open={openDialogRemove}
        title={tituloModalExclusao()}
        handleConfirm={submitExcluir}
      />
    </>
  );
}

export default Atividade;
